
// // import axios from 'axios';
// // import React, { useState, useEffect, useRef } from 'react';
// // import { WaveLoading } from 'react-loadingg'; // Import the WaveLoading component from the react-loadingg library
// // import {SendRequestFromChatbot} from '../api/apiHandler.js';

// // const Chatbot = () => {
// //   const initialMessage = {
// //     role: 'system',
// //     content: "Hi, I’m your Helprr Companion. I’m here if you want to talk something through, sort out what you’re feeling, or find a small next step. What’s on your mind today?"
// //   };

// //   const [messages, setMessages] = useState([]);
// //   const [inputText, setInputText] = useState('');
// //   const [loading, setLoading] = useState(false); // Add a loading state

// //   const chatRef = useRef(null);

// //   const handleSendMessage = async () => {
// //     const question = inputText.trim();
// //     if (question === '') return;

// //     setInputText('');
// //     const updatedMessages = [...messages, { role: 'user', content: question }];
// //     setMessages(updatedMessages);
// //     setLoading(true); // Set loading to true when sending a message

// //     try {

// //       // call the backend api
// //       SendRequestFromChatbot({'message' : updatedMessages}).then((response) => {
        
// //         if(response.status == 200){
// //           const botResponse = response.data.reply;
          
// //           setMessages(prevMessages => [...prevMessages, { role: 'system', content: botResponse }]);
// //         }
        
// //         }).catch((error) => {
// //             console.error('Error fetching chat response:', error);
// //         })

// //     } catch (error) {
// //       console.error('Error fetching chat response:', error);
// //     } finally {
// //       setLoading(false); // Set loading to false after receiving a response
// //     }
// //       // const response = await axios.post(
// //       //   process.env.REACT_APP_CHATGPT_CHATBOT_API_URL,
// //       //   {
// //       //     model: 'gpt-3.5-turbo',
// //       //     messages: updatedMessages,
// //       //     max_tokens: updatedMessages.reduce((totalTokens, message) => {
// //       //       const tokensInMessage = message.content.split(' ').length;
// //       //       return totalTokens + tokensInMessage;
// //       //     }, 0) + 700
// //       //   },
// //       //   {
// //       //     headers: {
// //       //       'Content-Type': 'application/json',
// //       //       'Authorization': `Bearer ${process.env.REACT_APP_CHATGPT_API_KEY}`
// //       //     }
// //       //   }
// //       // );

// //      // const botResponse = response.data.choices[0].message.content;
// //       //console.log('botResponse: ', botResponse);
// //      // setMessages(prevMessages => [...prevMessages, { role: 'system', content: botResponse }]);
   
// //   }

// //   useEffect(() => {
// //     setMessages([initialMessage]);
// //   }, []);

// //   useEffect(() => {
// //     if (chatRef.current) {
// //       chatRef.current.scrollTop = chatRef.current.scrollHeight;
// //     }
// //   }, [messages]);

// //   return (
// //     <div className="chat-container" style={{ backgroundColor: 'white' }}>
// //       <div id="chat" className="chat-box" ref={chatRef}>
// //         {loading && <WaveLoading color="#f27040" size="large" />} {/* Render the WaveLoading component while loading */}
// //         {messages.map((message, index) => (
// //           <div
// //             key={index}
// //             style={{
// //               display: 'flex',
// //               justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start',
// //               marginBottom: '8px'
// //             }}
// //           >
// //             <div
// //               style={{
// //                 backgroundColor: message.role === 'user' ? '#f27040' : 'rgb(234, 238, 243)',
// //                 color: message.role === 'user' ? 'rgb(234, 238, 243)' : 'black',
// //                 borderRadius: message.role === 'user' ? '10px 0 0 10px' : '0 10px 10px 0',
// //                 padding: '10px',
// //                 maxWidth: '80%', // Increase this value to increase the width
// //                 wordWrap: 'break-word'
// //               }}
// //             >
// //               {message.role === 'user' ? 'You:' : 'Buddy Helprr:'} {message.content}
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //       <div className='d-flex'>
// //         <input type="text" id="user-input" placeholder="Type your message..."
// //           value={inputText} autoComplete='off' onChange={(e) => setInputText(e.target.value)}
// //           onKeyUp={(e) => e.key === 'Enter' && handleSendMessage()} />
// //         <button className='chatbutton flex-1' onClick={handleSendMessage}>Send</button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Chatbot;
// import React, { useState, useEffect, useRef } from 'react';
// import { WaveLoading } from 'react-loadingg';
// import { SendRequestFromChatbot } from '../api/apiHandler.js';
// import './Chatbot.css';

// const Chatbot = () => {
//   const initialMessage = {
//     role: 'system',
//     content:
//       "Hi, I’m here if you want to talk something through, or find a small next step. What’s on your mind today?"
//   };

//   const starterPrompts = [
//     "I feel overwhelmed",
//     "I need motivation",
//     "I want to talk"
//   ];

//   const [messages, setMessages] = useState([initialMessage]);
//   const [inputText, setInputText] = useState('');
//   const [loading, setLoading] = useState(false);

//   const chatRef = useRef(null);

//   const handleSendMessage = async (customText) => {
//     const question = (customText || inputText).trim();
//     if (!question || loading) return;

//     setInputText('');

//     const updatedMessages = [
//       ...messages,
//       { role: 'user', content: question }
//     ];

//     setMessages(updatedMessages);
//     setLoading(true);

//     try {
//       const response = await SendRequestFromChatbot({
//         message: updatedMessages
//       });

//       if (response.status === 200) {
//         const botResponse = response.data.reply;

//         setMessages((prevMessages) => [
//           ...prevMessages,
//           { role: 'system', content: botResponse }
//         ]);
//       }
//     } catch (error) {
//       console.error('Error fetching chat response:', error);

//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           role: 'system',
//           content:
//             "Sorry, I’m having trouble responding right now. Please try again in a moment."
//         }
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (chatRef.current) {
//       chatRef.current.scrollTop = chatRef.current.scrollHeight;
//     }
//   }, [messages, loading]);

//   return (
//     <div className="chat-container">
//       <div id="chat" className="chat-box" ref={chatRef}>
//         {messages.map((message, index) => {
//           const isUser = message.role === 'user';

//           return (
//             <div
//               key={index}
//               className={`chat-message-row ${isUser ? 'user' : 'bot'}`}
//             >
//               <div className={`chat-message-bubble ${isUser ? 'user' : 'bot'}`}>
//                 {!isUser && (
//                   <div className="chat-message-name">
//                     Helprr Companion
//                   </div>
//                 )}

//                 <div className="chat-message-text">
//                   {message.content}
//                 </div>
//               </div>
//             </div>
//           );
//         })}

//         {messages.length === 1 && (
//           <div className="chat-starter-row">
//             {starterPrompts.map((prompt) => (
//               <button
//                 key={prompt}
//                 type="button"
//                 className="chat-starter-chip"
//                 onClick={() => handleSendMessage(prompt)}
//               >
//                 {prompt}
//               </button>
//             ))}
//           </div>
//         )}

//         {loading && (
//           <div className="chat-loading">
//             <WaveLoading color="#f27040" size="small" />
//           </div>
//         )}
//       </div>

//       <div className="chat-input-row">
//         <input
//           type="text"
//           id="user-input"
//           placeholder="Type your message..."
//           value={inputText}
//           autoComplete="off"
//           onChange={(e) => setInputText(e.target.value)}
//           onKeyUp={(e) => e.key === 'Enter' && handleSendMessage()}
//         />

//         <button
//           className="chatbutton"
//           onClick={() => handleSendMessage()}
//           disabled={loading}
//         >
//           Send
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Chatbot;
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { WaveLoading } from 'react-loadingg';
import { SendRequestFromChatbot } from '../api/apiHandler.js';
import './Chatbot.css';

const Chatbot = () => {
  const initialMessage = {
    role: 'assistant',
    content:
      "Hi, I’m here if you want to talk something through or find a small next step. What’s on your mind today?"
  };

  const starterPrompts = [
    "I feel overwhelmed",
    "I need motivation",
    "I want to talk"
  ];

  const supportActions = [
    { label: "Quick Reset", href: "/micro-exercises" },
    { label: "Find Local Support", href: "/resource-search" },
    { label: "Explore Content", href: "/content" },
    // { label: "Community", href: "/community" },
    // { label: "Build Your Plan", href: "/interests-page" },
  ];

  const [messages, setMessages] = useState([initialMessage]);
  const [inputText, setInputText] = useState('');
  const [loading, setLoading] = useState(false);

  const chatRef = useRef(null);
  const hasMountedRef = useRef(false);

  const handleSendMessage = async (customText) => {
    const question = (customText || inputText).trim();

    if (!question || loading) return;

    setInputText('');

    const updatedMessages = [
      ...messages,
      { role: 'user', content: question }
    ];

    setMessages(updatedMessages);
    setLoading(true);

    try {
      const response = await SendRequestFromChatbot({
        message: updatedMessages
      });

      if (response.status === 200) {
        const botResponse = response.data.reply;

        setMessages((prevMessages) => [
          ...prevMessages,
          { role: 'assistant', content: botResponse }
        ]);
      }
    } catch (error) {
      console.error('Error fetching chat response:', error);

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: 'assistant',
          content:
            "Sorry, I’m having trouble responding right now. Please try again in a moment."
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!chatRef.current) return;

    // First open: keep the welcome message visible
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      chatRef.current.scrollTop = 0;
      return;
    }

    // After messages: scroll normally
    chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [messages, loading]);

  const showInitialOptions = messages.length === 1 && !loading;

  return (
    <div className="chat-container">
      <div id="chat" className="chat-box" ref={chatRef}>
        {messages.map((message, index) => {
          const isUser = message.role === 'user';

          return (
            <div
              key={index}
              className={`chat-message-row ${isUser ? 'user' : 'bot'}`}
            >
              <div className={`chat-message-bubble ${isUser ? 'user' : 'bot'}`}>
                {!isUser && (
                  <div className="chat-message-name">
                    Helprr Companion
                  </div>
                )}

                <div className="chat-message-text">
                  {message.content}
                </div>
              </div>
            </div>
          );
        })}

        {showInitialOptions && (
          <>
            <div className="chat-starter-row">
              {starterPrompts.map((prompt) => (
                <button
                  key={prompt}
                  type="button"
                  className="chat-starter-chip"
                  onClick={() => handleSendMessage(prompt)}
                >
                  {prompt}
                </button>
              ))}
            </div>

            <div className="chat-tool-card">
              <p className="chat-tool-title">
                Or choose a Helprr tool:
              </p>

              <div className="chat-tool-pills">
                {supportActions.map((action) => (
                  <Link
                    key={action.label}
                    to={action.href}
                    className="chat-tool-pill"
                  >
                    {action.label}
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}

        {loading && (
          <div className="chat-loading">
            <WaveLoading color="#f27040" size="small" />
          </div>
        )}
      </div>

      <div className="chat-input-row">
        <input
          type="text"
          id="user-input"
          placeholder="Type your message..."
          value={inputText}
          autoComplete="off"
          onChange={(e) => setInputText(e.target.value)}
          onKeyUp={(e) => e.key === 'Enter' && handleSendMessage()}
        />

        <button
          className="chatbutton"
          onClick={() => handleSendMessage()}
          disabled={loading}
          type="button"
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;